import React from 'react'

import Text from '../Text'

interface SubtitleProps {
  children?: React.ReactNode
  sx?: object
}

const Subtitle: React.FC<SubtitleProps> = ({ children = null, sx = {} }) => (
  // TODO: check if subtitle1 matches subtitle from before
  <Text variant="subtitle1" component="h2" sx={sx}>
    {children}
  </Text>
)

export default Subtitle
